import _bind from 'lodash/bind';
import _isEqual from "lodash/isEqual";

import { waitUntil } from '../common/promise';
import { interval as intervalObs } from 'rxjs';
import { first as firstObs, skipUntil, skipWhile } from 'rxjs/operators';

export default {
  $esriModules: undefined,
  $esriObject: undefined,
  created () {
    _bind(defineLifeCyclePromises, this)();
  },
  async mounted () {
    await this.$createPromise;
    this._mounted = true;
  },
  async beforeDestroy () {
    await this.$mountPromise;
    this._mounted = false;
  },
  async destroyed () {
    await this.$unmountPromise;
    this.deinit();
  },
  methods: {
    async beforeInit () {
    },
    async init () {
      this.$esriModules = await this.loadEsriModules();
      this.$esriObject = await this.createEsriObject();
    },
    async deinit () {
      this.$esriModules = undefined;
      this.$esriObject = undefined;
    },
    async loadEsriModules () {
      return null;
    },
    async createEsriObject () {
      throw new Error('Method not implemented.');
    },
    async mount () {
    },
    async unmount () {
    },
    /**
     * @returns {Promise<unknown>}
     */
    wait (callback, timeout = 30 * 1000) {
      return waitUntil(timeout, callback);
    },
    waitForEsriObject () {
      return this.wait(() => !!this.$esriObject);
    },
    updateValue (key, value) {
      if (!_isEqual(this[key], value)) {
        this.$emit(`update:${ key }`, value);
      }
    },
    async set (key, value) {
      await this.waitForEsriObject();
      this.$esriObject[key] = value;
    }
  }
};

function defineLifeCyclePromises () {
  this.$createPromise = Promise.resolve(this.beforeInit())
    .then(() => this.init());

  const mountObs = intervalObs(1000 / 60)
    .pipe(
      skipWhile(() => !this._mounted),
      firstObs()
    );
  this.$mountPromise = mountObs.toPromise(Promise)
    .then(() => this.mount());

  const unmountObs = intervalObs(1000 / 60)
    .pipe(
      skipUntil(mountObs),
      skipWhile(() => this._mounted),
      firstObs()
    );
  this.$unmountPromise = unmountObs.toPromise(Promise)
    .then(() => this.unmount());
}
